import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

import { FlexLayoutModule } from '@angular/flex-layout';

import { FormsModule } from '@angular/forms';
import { KeepAliveInterceptor } from './keepAliveInterceptor.class';
import { KeepAliveService } from './keep-alive.service';
import { KeepAliveDialogComponent } from './keep-alive-dialog/keep-alive-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [KeepAliveDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    MatDialogModule,MatCardModule,MatButtonModule    
  ],
  providers: [
     KeepAliveService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeepAliveInterceptor,
      multi: true
    }
  ],
  entryComponents: [KeepAliveDialogComponent],
})
export class KeepAliveModule { }

